import Vue from 'vue'
import Vuex from 'vuex'
import { supabase } from '@/supabase' // Import the supabase client

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: {
      id: -1,
      name: '',
      email: '',
      address: '',
      role: ''
    },
    isLogin: false,
    cartItems: [], // Array to hold cart items { id, name, price, quantity, image }
    cartItemNumber: 0,
    appliedCoupon: null,
    discountAmount: 0
  },
  mutations: {
    setNavbarCartItemNumber (state) {
      state.cartItemNumber = state.cartItems.reduce((total, item) => total + item.quantity, 0)
    },
    addCartItem (state, variant) {
      // Find item in cart by a unique identifier for the variant, e.g., SKU or a composite key.
      // Here we'll use variant ID, assuming it's unique per variant.
      const existingItem = state.cartItems.find(p => p.id === variant.id)

      if (existingItem) {
        existingItem.quantity += variant.quantity
      } else {
        // Ensure we are adding a variant object, not a product object.
        // The object should contain all necessary info for the cart.
        state.cartItems.push(variant)
      }
      this.commit('setNavbarCartItemNumber')
    },
    removeCartItem (state, variantId) {
      state.cartItems = state.cartItems.filter(p => p.id !== variantId)
      this.commit('setNavbarCartItemNumber')
    },
    clearCart (state) {
      state.cartItems = []
      this.commit('setNavbarCartItemNumber')
    },
    setCurrentUser (state, currentUser) {
      console.log('setCurrentUser', currentUser)
      state.currentUser = {
        ...state.currentUser, // preserve any other properties
        ...currentUser
      }
      state.isLogin = true
    },
    logout (state) {
      console.log('vuex-logout')
      state.currentUser = {
        id: -1,
        name: '',
        email: '',
        address: '',
        role: ''
      }
      state.isLogin = false
      localStorage.removeItem('token')
      this.commit('clearCart') // Clear cart on logout
    },
    setAppliedCoupon (state, { coupon, discountAmount }) {
      state.appliedCoupon = coupon
      state.discountAmount = discountAmount
    },
    clearAppliedCoupon (state) {
      state.appliedCoupon = null
      state.discountAmount = 0
    }
  },
  actions: {
    async fetchCurrentUser ({ commit }) {
      try {
        console.log('fetchCurrentUser: 開始獲取使用者資料...')

        // Use Supabase v1 API
        const user = supabase.auth.user()

        console.log('fetchCurrentUser: user =', user)

        if (!user) {
          console.log('No user logged in.')
          commit('logout')
          return
        }

        console.log('fetchCurrentUser: 使用者已登入，ID =', user.id)

        // Fetch the user's profile from the 'profiles' table
        const { data: profile, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', user.id)
          .single()

        console.log('fetchCurrentUser: profile =', profile)
        console.log('fetchCurrentUser: profile error =', error)

        if (error) {
          console.error('fetchCurrentUser: 獲取 profile 失敗:', error)
          throw error
        }

        if (profile) {
          console.log('fetchCurrentUser: 設定使用者資料到 store')
          commit('setCurrentUser', {
            id: profile.id,
            name: profile.name || user.email,
            email: profile.email,
            address: profile.address,
            role: profile.role,
            phone_number: profile.phone_number,
            date_of_birth: profile.date_of_birth
          })
        }
      } catch (error) {
        console.error('Error fetching current user:', error)
        commit('logout')
      }
    },
    async logout ({ commit }) {
      try {
        // Sign out from Supabase
        const { error } = await supabase.auth.signOut()
        if (error) {
          console.error('Supabase sign out error:', error)
        }
      } catch (error) {
        console.error('Error during logout:', error)
      } finally {
        // Always clear local state
        commit('clearUser')
      }
    }
  }
})
